import { render, staticRenderFns } from "./ExTable.vue?vue&type=template&id=48de3146"
import script from "./ExTable.vue?vue&type=script&lang=js"
export * from "./ExTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports